import React, { PureComponent } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { PortalConfigContext } from '../../config/portal';
import { geti18nLocations, getCurrentLocale } from '../../utils/language';
import { setProductImpression } from '../../store/actions/dataLayer';
import { premiumFeaturedAdPropTypes } from '../../utils/commonPropTypes';
import messages from '../../utils/translationMessages';
import * as utils from '../../store/utils';
import { getAssetUrl } from '../../utils/commonHelper';
import { addResizeParams } from '../../utils/listingHelper';
import { setListingClick } from '../../store/actions/dataLayer';
import './styles.css';

class HeroViewer extends PureComponent {

  state = {
    imageLoaded: false,
    imageError: false,
    attemptImageLoad: false
  };

  handleImageLoaded() {
    this.setState({imageLoaded: true});
  }

  handleImageError() {
    this.setState({imageError: true});
  }

  componentDidMount(){
    const { ad } = this.props;
    if (ad) {
      const { imtId: id } = ad;
      this.props.setProductImpression(id, 'hero ad', undefined, 1);
    }
    if (!utils.isServer()) {
      let {images} = this.props;
      let image = images[Math.round(Math.random() * (images.length - 1))];
      this.setState({attemptImageLoad: true, image: image});
    }
  }

  renderStockImage(lazyLoad, alt) {
    return <div className="hero">
      {
        this.state.image && !this.state.imageError ?
          <LazyLoadImage
            src={getAssetUrl(this.state.image)} alt={alt}
            onLoad={this.handleImageLoaded.bind(this)}
            onError={this.handleImageError.bind(this)}
            className={'hero-image'}
            visibleByDefault={!lazyLoad}
            threshold = {200}
          />
          : null
      }
    </div>;
  }

  getLocaleAdURL(adUrl) {
    const context = get(this, 'context', {});
    const supports = get(context, 'supports');
    const multiLanguage = get(supports, 'multiLanguage');

    if (multiLanguage) {
      const urlPathname = new URL(adUrl).pathname;
      const urlObjectArray = geti18nLocations(urlPathname);
      const locale = getCurrentLocale();

      for (const urlObject of urlObjectArray) {
        if (urlObject.lang === locale) {
          return urlObject.route;
        }
      }
    }
    return adUrl;
  }

  renderInfoBar(ad) {
    let url;
    const { intl: { formatMessage: t } } = this.props;
    url = get(ad, 'listingUrl');

    if (url) {
      url = this.getLocaleAdURL(url);
    } else {
      url = get(ad, 'externalUrl');
    }

    return <div className="hero-info-bar">
      <div className="hero-text">
        <div className="hero-text-title">{ad.title}</div>
        <div className="hero-text-description">{`${t(messages.hero.heroPresentedBy)} ${ad.provisioningName}`}</div>
      </div>
      <div className="hero-elements">
        <img className="hero-elements-logo" src={addResizeParams(ad.logoUrl, {width: 124,height: 45}, ad.start, false)} alt={ad.provisioningName}/>
        <a href={url}
          data-reporting-click-listing-type="hero ad"
          data-reporting-click-product-id={ad.imtId}
          data-reporting-page="1"
          data-reporting-rank=""
          data-reporting-listing-container="n/a"
          onClick={ () => setListingClick(ad.imtId, 'hero ad', '', '') }
          className="hero-elements-button">
          {t(messages.hero.heroLearnMore)}
        </a>
      </div>
    </div>;
  }

  renderHeroAd(ad) {
    let { resize } = this.props;
    const imageParams = {
      srcSet: `${addResizeParams(ad.photoUrl, {width: 500,height: 200}, ad.start, true)} 500w,
              ${addResizeParams(ad.photoUrl, {width: 970, height: 267}, ad.start, true)} 970w,
              ${addResizeParams(ad.photoUrl, {width: 1440, height: 500}, ad.start, true)} 1440w`,
      sizes: '(max-width: 1440px) 100vw, 1440px',
      src: addResizeParams(ad.photoUrl, resize, ad.start, true),
      alt: ad.title
    };
    return <>
      <div className="hero with-ad">
        <img {...imageParams} className="hero-image" onLoad={this.handleImageLoaded.bind(this)} onError={this.handleImageError.bind(this)}
        />
        {!ad.hideInfobar && this.renderInfoBar(ad)}
      </div>
    </>;
  }

  render(){
    let {
      lazyLoad,
      alt,
      ad
    } = this.props;

    if (!this.state.attemptImageLoad) {
      return <>
        <div className="hero"></div>
      </>;
    }
    if (ad) {
      return (this.renderHeroAd(ad, lazyLoad));
    }
    return (this.renderStockImage(lazyLoad, alt));
  }
}


HeroViewer.defaultProps = {
  lazyLoad: false,
  resize: {},
};


HeroViewer.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
  /** Make image visible by default */
  lazyLoad: PropTypes.bool,
  alt: PropTypes.string.isRequired,
  ad: premiumFeaturedAdPropTypes,
  setProductImpression: PropTypes.func.isRequired,
  /** Resize specifications for the image */
  resize: PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
  }),
};

HeroViewer.contextType = PortalConfigContext;

export default connect(
  null,
  dispatch => bindActionCreators({
    setProductImpression,
  }, dispatch)
)(injectIntl(HeroViewer));
